export default "__VITE_PUBLIC_ASSET__44fe6ab7__"